import { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { setLocalStorageAccessToken } from "utils/helpers/localStorage";
import { getProfileRequest } from "api/auth";
import { useAuth } from "utils/hooks/useAuth";

const LoggedInCallbackRoute: React.FC = () => {
  const location = useLocation();
  const searchPararms = new URLSearchParams(location.search);
  const token = searchPararms.get("token");

  const navigate = useNavigate();
  const { setProfile, setIsAuth } = useAuth();
  const defaultRoute =
    sessionStorage.getItem("redirectTo") || "/layout/6";
  

  /**
   * Get jwt token by query params
   * then ask backend for user informations
   */
  useEffect(() => {
    if(token === null) {
    } else {
        setLocalStorageAccessToken(token);

        getProfileRequest().then((res) => {
            setProfile(res.data as any);
            setIsAuth(true);

             navigate(defaultRoute, { replace: true });
        });

        
       
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  

  return (
    <div>Loading...</div>
  );
}

export default LoggedInCallbackRoute;